import { render, staticRenderFns } from "./AccountSwitcherIcon.vue?vue&type=template&id=0b5c09df"
import script from "./AccountSwitcherIcon.vue?vue&type=script&lang=js"
export * from "./AccountSwitcherIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports